import { FC } from 'react';

import { PlayerCell } from '@wwe-portal/ui/features/leaderboard/leaderboard-row';
import { PlayerAvatar } from '../common/image/player-avatar';
import { PlayerLink } from '../common/link/player-link';
import { FactionLink } from '../common/link/faction-link';
import { useTranslations } from 'next-intl';

export const PlayerNameCell: FC<{
  compact?: boolean;
  hideAvatar?: boolean;
  data: {
    faction?: string;
    name: string;
    userId?: string;
  };
}> = ({ data: { faction, name, userId }, hideAvatar, compact }) => {
  const t = useTranslations();
  return (
    <PlayerCell
      avatar={
        hideAvatar ? null : (
          <PlayerAvatar
            className="h-[26px] w-[26px]"
            userId={userId}
            userName={name}
          />
        )
      }
      faction={
        compact ? (
          <FactionLink
            className="text-text500 hover:text-text300 3xl:hidden hidden transition duration-300 ease-linear hover:no-underline 2xl:block"
            name={faction || ''}
          >
            {faction ?? t('no_faction')}
          </FactionLink>
        ) : null
      }
      name={
        <PlayerLink className="no-underline hover:no-underline" name={name}>
          <div className="text-text300 font-normal transition duration-300 ease-linear hover:text-white">
            {name}
          </div>
        </PlayerLink>
      }
    />
  );
};
